<div pTooltip="Enable Price Tier" tooltipPosition="top" style="display: inline-block">
  <p-inputSwitch [(ngModel)]="enable" (onChange)="loadPriceTiers(enable)"></p-inputSwitch>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)" *ngIf="enable">
    <p-tabPanel header="Price Tiers">
        <app-pricing [allTiers]="allTiers" (showEdit)="showEditPricing($event)" (deleteConfirm)="deleteTier($event)"
          (viewProducts)="openProducts($event)"></app-pricing>
    </p-tabPanel>
    <p-tabPanel header="Discount by Group">
      <app-group [allTiers]="allTiers" (showEditGroup)="showEditPricing($event)" (deleteConfirmGroup)="deleteTier($event)"
      (viewGroupProducts)="openProducts($event)"></app-group>
    </p-tabPanel>
    <p-tabPanel header="Assign Price Discount">
      <app-assign [types]="types" [allTiers]="allTiers"></app-assign>
    </p-tabPanel>
    <p-tabPanel header="PriceTier Discount">
      <app-discount-select></app-discount-select>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
      <ng-template pTemplate="header">
        <p-menu #configmenuInventory id="config_menu_inventory" [model]="configMenuInventoryItems"
          [popup]="true" appendTo="body">
        </p-menu>
        <span class="btnBars p-mr-0" (click)="configmenuInventory.toggle($event)">
          <i class="pi pi-bars"></i>
        </span>
      </ng-template>
    </p-tabPanel>
</p-tabView>


<p-dialog header="{{addEditPricingHeader}}" [(visible)]="displayPricingAddEdit" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}" (onHide)="tierForm.reset();">
    <form [formGroup]="tierForm">
        <div class="header">
            <h5>Pricing Information
                <p-inputSwitch class="header-switch" formControlName="statusId"></p-inputSwitch>
            </h5>
        </div>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-6">
                        <label>Product Discount Type  <span style="color: red;">*</span></label>   
                        <p-dropdown [options]="types" formControlName="typeId" optionLabel="name"
                        appendTo="body" placeholder="Select Product Discount Type"></p-dropdown>
                    </div>
                    <div class="p-col-6" *ngIf="tierForm.controls['typeId'].value?.name==discountQtyType">
                        <label>Custom Price</label>  
                        <p-checkbox binary="true" formControlName="isCustom" (onChange)="setDiscountValidation($event)"></p-checkbox> 
                    </div>
                    <!-- <div class="p-col-6" *ngIf="tierForm.controls['typeId'].value?.name==discountGroupType">
                      <label>Product Group Types</label>  
                      <p-dropdown [options]="groupTypes" optionLabel="name" appendTo="body"></p-dropdown>
                    </div> -->
                </div>
                <div class="p-grid">
                    <div [ngClass]="tierForm.controls['isCustom'].value ? 'p-col-12' : 'p-col-6'">
                        <label *ngIf="tierForm.controls['typeId'].value?.name==discountQtyType || !tierForm.controls['typeId'].value">Price Tier Name
                            <span style="color: red;">*</span>
                        </label>
                        <label *ngIf="tierForm.controls['typeId'].value?.name==discountGroupType">Product Group Name
                            <span style="color: red;">*</span>
                        </label>
                        <input type="text" pInputText formControlName="name" (focusout)="checkDuplicateTierName()" />
                        <span *ngIf="duplicateTier" style="color: red;">Tier name already exists.</span>
                    </div>
                    <div class="p-col-6" *ngIf="!tierForm.controls['isCustom'].value">
                        <label>Markup/Discount(%) <span style="color: red;">*</span>
                        <span class="btnBars p-mr-0" pTooltip="For discount add (-ve) sign, for e.g -10" tooltipPosition="top"><i class="pi pi-info-circle"></i></span>  
                        </label> 
                      
                        <!-- <p-inputNumber mode="decimal" inputId="withoutgrouping"
                        [useGrouping]="false" formControlName="markup"></p-inputNumber> -->
                        <input type="text" pInputText formControlName="markup" />
                    </div>
                </div>
            </div>
    </form>
    <p-footer>
      <button type="button" pButton (click)="displayPricingAddEdit=false" label="Cancel" class="p-button-secondary"></button>
      <button type="button" pButton label="Save" (click)="save(tierForm.value)" 
      [disabled]="!tierForm.valid || isDisabled || duplicateTier"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Warning" [(visible)]="displayProductAvailability" [modal]="true" [responsive]="true"
[style]="{width: '60vw'}">
<div class="header">
  <h5>{{warningText}}</h5>
</div>
<div class="card">
  <span style="font-weight: bold;">This {{index==0?'Tier':'Group'}} is associated with below Accounts.</span><br>
  <span>{{associatedProducts}}</span>
</div>
</p-dialog>

<!-- For Pricing -->
<p-dialog header="{{selectedDiscountType?.name}}" [(visible)]="displayPricingTB" [modal]="true" [responsive]="true" [style]="{width: '80vw'}" [closable]="false">
  <div class="card">
      <p-table #dt [value]="pricingData" (onPage)="getData($event)"  [lazy]="true"
       [paginator]="true" [totalRecords]="totalRecords" [rows]="pageSize" [showCurrentPageReport]="true"
       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [first]="first">
          <ng-template pTemplate="caption">
            <div class="p-gird p-d-flex">
              <div class="p-col-3">
                  <input pInputText type="text" (ngModelChange)="changed($event,'account')" 
                  [(ngModel)]="searchValue" placeholder="Search..." />
              </div>
            </div>
              <div class="p-gird p-d-flex">
                  <div class="p-col-2">
                  <p-dropdown [options]="wareHouseList" optionLabel="customName" appendTo="body" 
                  [(ngModel)]="selectedLocation" placeholder="Select Location" (onChange)="productByCate()"></p-dropdown>
                  </div>
                  <div class="p-col-1"  *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType">
                    <p-dropdown [options]="levels" optionLabel="number" appendTo="body" optionValue="number"
                    [(ngModel)]="selectedLevel" placeholder="Select Level"></p-dropdown>
                    </div>
                  <div class="p-col-2">
                      <p-dropdown [options]="productChannels" [(ngModel)]="selectedTBChannel" 
                      optionLabel="name" appendTo="body" (onChange)="onTypeChange()"></p-dropdown>
                  </div>
                  <div class="p-col-2">
                      <p-dropdown [options]="category" optionLabel="name" appendTo="body" 
                      [(ngModel)]="selectedCategory" placeholder="Select Category" (onChange)="productByCate()"></p-dropdown>
                  </div>
                  <div class="p-col-2">
                    <p-dropdown [options]="manufacturer" optionLabel="name" appendTo="body" 
                    [(ngModel)]="selectedManufacturer" placeholder="Select Manufacurer" (onChange)="productByManufacturer()"></p-dropdown>
                  </div>
                  <div *ngIf="discountType!='addbulkitemtogroup'" [ngClass]="selectedDiscountType?.name == discountQtyType ? 'p-col-2' : 'p-col-3'">
                      <p-multiSelect [options]="tiers" [(ngModel)]="selectedTiers" optionLabel="name" 
                      appendTo="body" placeholder="Select Tier" *ngIf="selectedDiscountType?.name == discountQtyType"></p-multiSelect>
                      <p-dropdown [options]="tiers" [(ngModel)]="selectedTier" optionLabel="name" (onChange)="productByGroup()"
                      appendTo="body" placeholder="Select Group" *ngIf="selectedDiscountType?.name == discountGroupType"></p-dropdown>
                  </div>
                  <div class="p-col-1" *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType">
                      <p-button label="Apply All" (click)="applyAll()" [disabled]="selectedTiers?.length==0 || isDisabled"></p-button>
                  </div>
              </div>
          </ng-template>
          <ng-template pTemplate="header">
              <tr>
                  <th>Item No.</th>
                  <th>Item Details</th>
                  <th>Cost</th>
                  <th>Base Price</th>
                  <th *ngIf="discountType!='addbulkitemtogroup'">Discount Tier</th>
                  <th *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType">Tier Level</th>
                  <th *ngIf="discountType=='addbulkitemtogroup'">Discount Markup</th>
                  <th class="action" *ngIf="discountType=='addbulkitemtogroup' && selectedDiscountType?.name == discountGroupType">
                    <p-checkbox [binary]="true" [(ngModel)]="allChecked" (onChange)="setAllProduct($event)"></p-checkbox>
                  </th>
                  <th class="action" style="width: 2rem;" *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType">
                      <span class="btnBars p-mr-0">
                          <i class="pi pi-pencil" (click)="isEdit = !isEdit"></i>
                      </span>
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr>
                  <td>{{item.itemNo}}</td>
                  <td>{{item.description}}</td>
                  <td>{{item.cost}}</td>
                  <td>{{item.price}}</td>
                  <td *ngIf="discountType!='addbulkitemtogroup' && !isEdit">
                    <ng-container *ngFor="let s of item.productPriceTier; let i = index;">
                      <span>{{s.name}}</span>
                      <span *ngIf="item.productPriceTier?.length > 1 && i !== item.productPriceTier?.length-1">,</span>
                  </ng-container>
                  </td>
                  <td *ngIf="discountType!='addbulkitemtogroup' && isEdit" class="action">
                      <p-multiSelect [options]="priceTierList" [(ngModel)]="item.productPriceTier" optionLabel="name" appendTo="body" 
                      placeholder="Select Tier" (onChange)="onChangeTier(item)"></p-multiSelect>
                  </td>
                  <td *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType  && !isEdit">{{item.qtyLevel}}</td>
                  <td *ngIf="discountType!='addbulkitemtogroup' && selectedDiscountType?.name == discountQtyType  && isEdit" class="action">
                    <p-dropdown [options]="levels" optionLabel="number" appendTo="body" (onChange)="onChangeTier(item)"
                    [(ngModel)]="item.qtyLevel" placeholder="Select Level" optionValue="number"></p-dropdown>
                  </td>
                  <td *ngIf="discountType=='addbulkitemtogroup'">{{selectedGroup?.markup}}%</td>
                  <td class="action" *ngIf="discountType=='addbulkitemtogroup' || selectedDiscountType?.name == discountQtyType">
                    <p-checkbox [binary]="true" [(ngModel)]="item.isChecked" [disabled]="discountType!='addbulkitemtogroup'" (onChange)="addItemToGroup($event,item)"></p-checkbox>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td colspan="10"><div class="p-text-center">{{noProdcuctsFindOrLoadingText}}</div></td>
            </tr>
        </ng-template>
      </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayPricingTB = false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"  [disabled]="selectedItems?.length==0 || isDisabled" (click)="saveBulkProductTier()"></button>
  </p-footer>
</p-dialog>